// extracted by mini-css-extract-plugin
export var section = "logos-module--section--240f5";